import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useUser } from "./Context/UserProvider";

function ProtectedRoute({ children }) {
  const {
    isLoggedIn,
    isLoading,
    isSessionRecoveryPending,
    isExpedienteAccessChoicePending,
  } = useUser();
  const location = useLocation();
  const isGuestExpedienteEntry =
    location.pathname === "/expedientes/ver" &&
    Boolean(new URLSearchParams(location.search).get("id"));

  // isSessionRecoveryPending: el Swal de renovación está abierto.
  // No redirigimos al login; dejamos que el componente actual permanezca
  // visible detrás del modal para preservar formularios en curso.

  if (isGuestExpedienteEntry && !isLoggedIn) {
    return null;
  }

  if (
    !isLoading &&
    !isLoggedIn &&
    !isSessionRecoveryPending &&
    !isExpedienteAccessChoicePending
  ) {
    // console.log("Protected Route isLoggedIn", isLoggedIn);

    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  const content = children || <Outlet />;

  return !isLoading ? content : null;
}

export default ProtectedRoute;
